// --------------------------------------------------------------------------
// Under Age
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
    var ref = { $root: options.context, $document: jQuery(document) };
    var state = {
        underAge: null,
        dob: null
    };

    function render() {
        // remove any previous error message
        ref.$form.find('[data-name="under-age-custom-dob-error"]').remove();

        // show DoB error message
        if (state.showDobError) {
            var messageError = 'Please enter your date of birth';
            // display the new validation error message
            ref.$form.find('[data-binding="report-as-email-dob"]').prepend('<div class="validation-summary" data-name="under-age-custom-dob-error"><div class="validation-summary-errors"><li>' + messageError + '</li></div></div>');
            // add a custom bottom margin
            ref.$form.find('[data-name="under-age-custom-dob-error"]').css('margin-bottom', '20px');
        }
    }

    function getFormValues() {
        return {
            underAge: ref.$inputUnderAge.filter(':checked').val(),
            dobDay: ref.$dobDay.val(),
            dobMonth: ref.$dobMonth.val(),
            dobYear: ref.$dobYear.val(),
            showDobError: false
        };
    }

    function onAgeChange(event) {
        state = getFormValues();

        state.showDobError = false;

        if (state.underAge == 'Yes' || state.underAge == 'yes') {
            if (!parseInt(ref.$dobDay.val()) > 0 || !parseInt(ref.$dobMonth.val()) > 0 || !parseInt(ref.$dobYear.val()) > 0) {
                state.showDobError = true;
            }
        }

        // Trigger render
        render();
    }

    function init() {
        // Cache DOM elements
        ref.$form = ref.$root.closest('form');
        ref.$inputUnderAge = ref.$form.find('input[name="ContactDetails.UnderAgeString"]');
        ref.$optionsUnderAge = ref.$form.find('[data-binding="contact-details-underage"]');
        ref.$dobDay = ref.$form.find('[data-binding="contact-details-dob-day"]');
        ref.$dobMonth = ref.$form.find('[data-binding="contact-details-dob-month"]');
        ref.$dobYear = ref.$form.find('[data-binding="contact-details-dob-year"]');
        // array of all block's inputs
        ref.$inputs = [$(ref.$inputUnderAge[0]), // take each radio group input and convert to jQuery element
        $(ref.$inputUnderAge[1]), ref.$dobDay, ref.$dobMonth, ref.$dobYear];

        // add jQuery validaion
        $.each(ref.$inputUnderAge, function (index, input) {
            if (typeof $.data(input.form, 'validator') !== 'undefined') {
                $(input).rules('add', 'required');
            }
        });

        // Set state
        function initialState() {
            return getFormValues();
        }

        state = initialState();

        ref.$optionsUnderAge.on('change', onAgeChange);
        ref.$dobDay.on('change', onAgeChange);
        ref.$dobMonth.on('change', onAgeChange);
        ref.$dobYear.on('change', onAgeChange);

        // Render component
        render();
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/under-age.js
// module id = 504
// module chunks = 0